import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { useNavigate } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const AutomaticLoginFailure = () => {
  const navigate = useNavigate();

  return (
    <Stack className="w-full" align="start" gap={6}>
      <Text variant="title" className="mt-4">
        Password changed
      </Text>
      <Text tone="muted">
        Your password was changed successfully, but automatic sign-in failed.
        Sign in manually with your new password.
      </Text>
      <Button
        type="button"
        size="lg"
        variant="ghost"
        onClick={() => navigate("/login")}
        className="w-full"
      >
        <ArrowLeftIcon data-icon="inline-start" />
        Sign in manually
      </Button>
    </Stack>
  );
};
